import styled from "@emotion/styled";
import { PopupDialog } from "molecule/popupDialog/PopupDialog";
import { APP_BREAKPOINT } from "src/constants/layout";
import { ShippingAddressData } from "src/state/ShippingAddress/ShippingAddressData";

export type ShippingAddressSuggestionOption = "suggested" | "original";

const SuggestionDialog = styled(PopupDialog)`
  --popup-modal-background: var(--color-white, #ffffff);
  --popup-dialog-width: 27.6875rem /* 443/16 */;
  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    --popup-dialog-width: 21.4375rem; /* 343/16 */
  }
`;

const TilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem /* 16/16 */;
  margin-top: 1.5rem /* 24/16 */;
  isolation: isolate;
`;

const Tile = styled.label`
  display: flex;
  position: relative;
  align-items: flex-start;
  gap: 0.75rem;
  isolation: isolate;
  border-radius: 8px;
  cursor: pointer;
  padding: 24px;
  border: 1px solid transparent;
  box-sizing: border-box;
  background:
    linear-gradient(
        var(--gradient-dir, to right),
        var(--color-white, #ffffff),
        var(--color-white, #ffffff)
      )
      padding-box,
    linear-gradient(
        var(--gradient-dir, to right),
        var(--Greys-Light-Gray, #e6e3db),
        var(--Greys-Light-Gray, #e6e3db)
      )
      border-box;
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    left: -1.5px;
    top: -1.5px;
    width: 100%;
    height: 100%;
    filter: opacity(0);
    border-radius: 8px;
    transition: filter var(--ease-time-short, 200ms) ease-in-out;
    border: 1.5px solid transparent;
    background:
      linear-gradient(
          var(--gradient-dir, to right),
          var(--color-white, #ffffff),
          var(--color-white, #ffffff)
        )
        padding-box,
      linear-gradient(
          var(--gradient-dir, to right),
          var(--color-sunrise-blue) 13.49%,
          var(--color-sunrise-pink) 51.22%,
          var(--color-sunrise-orange) 85.11%
        )
        border-box;
  }
  &[data-is-selected]:before {
    filter: opacity(1);
  }
`;

const TileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

const TileLabel = styled.span`
  font-size: 0.875rem /* 14/16 */;
  color: var(--color-charcoal-50, rgba(33, 33, 33, 0.5));
  line-height: 140%;
`;

const TileAddress = styled.span`
  font-size: 1rem;
  color: var(--color-charcoal, #212121);
  line-height: 140%;
  letter-spacing: -0.02em;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex: 0 0 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem /* 12/16 */;
`;

const formatAddress = (address: ShippingAddressData): string =>
  `${address.street ?? ""}${address.aptSuite ? `, ${address.aptSuite}` : ""}\n${address.city ?? ""}, ${address.state ?? ""} ${address.zip ?? ""}`;

export const ShippingFormAddressSuggestionStyled = {
  SuggestionDialog,
  TilesContainer,
  Tile,
  TileLabel,
  TileAddress,
  TileContent,
  ActionsContainer,
  formatAddress
};
